import type { ReactNode } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const LOGOMARK = 'https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png'

/** The centred card the password reset pages sit in. */
export default function AuthCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center py-8">
      <div className="fixed inset-0 -z-10 bg-[#F4F7EF]"></div>
      <div className="w-full max-w-md px-4">
        <Card className="rounded-[28px] border-0 bg-[#FFFFFF] py-4 shadow-[0_20px_60px_rgba(16,24,40,0.08)] sm:px-4">
          <CardHeader className="pb-0 text-center">
            <div className="mb-4 flex justify-center">
              <img src={LOGOMARK} alt="Athios Logo" className="h-10 w-10" />
            </div>
            <CardTitle className="text-2xl font-bold text-[#0F172A]">{title}</CardTitle>
          </CardHeader>
          <CardContent className="pt-6">{children}</CardContent>
        </Card>
      </div>
    </div>
  )
}
